module.exports = __webpack_public_path__ + "static/media/desktop-picture-retina-large.93c86973.jpeg";